// extracted by css-extract-rspack-plugin
export default {"root":"root-DS1zsD"};